import { useState } from "react";

// Copies text to the clipboard and flashes a confirmation. Falls back to a
// no-op label if the Clipboard API is unavailable (e.g. insecure context).
export function CopyButton({
  text,
  label = "Copy",
  className = "btn-secondary",
}: {
  text: string;
  label?: string;
  className?: string;
}) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Ignore; user can still select manually.
    }
  }

  return (
    <button className={className} onClick={copy} type="button">
      {copied ? "Copied" : label}
    </button>
  );
}
